import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../styles/palette';

export const useStyles = makeStyles()((theme, { width, labelColor } = {}) => ({
  control: { minWidth: 96, width },
  label: labelColor ? { color: labelColor } : {},
  requiredWithGap: { marginLeft: '4px', color: colors.gilead.primary1 },
  menuItem: {
    height: 29,
    paddingBottom: 0,
    paddingTop: 0,
  },
  checkbox: {
    '& svg': {
      borderRadius: 4,
      height: 20,
      width: 20,
    },
  },
}));
